import { t } from '@lingui/macro';
import { PlaiViewType } from '../../PlaiProvider';
export const getViewLabel = (view) => {
    switch (view) {
        case PlaiViewType.Review:
            return t({
                comment: 'Plai Drawer - Tab title - Review',
                message: 'Review',
            });
        case PlaiViewType.Playbook:
            return t({
                comment: 'Plai Drawer - Tab title - Playbook',
                message: 'Playbook',
            });
        default:
            return null;
    }
};
